import { useQueryClient } from '@tanstack/react-query';

import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { useNotifications } from '../../context/notifications-context';
import { NotificationType } from '../../types/notification.types';
import { useAppMutation } from '../use-app-mutation.hook';

export const useMarkRead = ({
  companyId,
  onSuccess,
}: {
  companyId: string;
  onSuccess?: () => void;
}) => {
  const queryClient = useQueryClient();
  const { handleReadNotification } = useNotifications();
  const { mutate: markAsRead } = useAppMutation([QueryKey.MARK_NOTIFICATION_AS_READ, companyId], {
    mutationFn: ({ id, type }: { id: string; type: NotificationType }) =>
      ApiService.post({
        endpoint: BackendRoute.COMPANIES,
        routePath: [companyId, 'notifications', id, 'mark-read'],
      }),
    onSuccess: (_, { type }) => {
      onSuccess?.();
      handleReadNotification(type);
      queryClient.invalidateQueries({ queryKey: [QueryKey.GET_UNREAD_NOTIFICATION_COUNT] });
      queryClient.invalidateQueries({ queryKey: [QueryKey.GET_NOTIFICATIONS] });
    },
  });

  return {
    markAsRead,
  };
};
